import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-jamsole',
  templateUrl: './why-jamsole.component.html',
  styleUrls: ['./why-jamsole.component.css']
})
export class WhyJamsoleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
